module.exports = __webpack_public_path__ + "static/media/desktop.3a9f466.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/Melon/desktop.mp4
// module id = xtnB
// module chunks = 1